<template>
  <div class="min-h-full rounded overflow-hidden md:shadow-lg">
    <template v-if="!useCarousel">
      <slot name="image">
        <img
          v-if="imageSrc"
          class="object-cover min-w-full min-h-full"
          :style="{ maxHeight: '411px', maxWidth: '309px' }"
          :src="imageSrc"
          :alt="imageAlt"
        />
      </slot>
      <div v-if="callToAction || text || title" class="px-6 py-4">
        <div v-if="title" class="font-site font-bold text-2-1/2 mb-4 text-wine">{{ title }}</div>
        <slot name="content">
          <p v-if="text" class="text-gray-700 text-2xl">
            {{ text }}
          </p>
          <button
            v-if="callToAction"
            class="inline-block bg-gray-200 rounded px-8 py-6 mt-4 text-base font-semibold text-gray-700"
            @click="navigateTo"
          >
            {{ callToAction }}
          </button>
        </slot>
      </div>
    </template>
    <carousel v-else :slides="slides" :autoplay="autoplay" />
  </div>
</template>

<script>
import cardMixin from '@/components/card/card.mixin'
import Carousel from '@/components/layout/Carousel'

export default {
  components: { Carousel },
  mixins: [cardMixin],
  computed: {
    useCarousel() {
      return this.slides && this.slides.length > 0
    },
  },
  methods: {
    navigateTo() {
      this.$router.push(this.target)
    },
  },
}
</script>

<style lang="scss" scoped>
.text-2-1\/2 {
  font-size: 2.5rem;
}
</style>
